var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFranceFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100%",
    viewBox: "0 0 275 183",
    enableBackground: "new 0 0 275 183",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CE1126",
    opacity: 1,
    stroke: "none",
    d: " M185.000000,1.000000  C215.296844,1.000000 245.593689,1.000000 275.945251,1.000000  C275.945251,61.890095 275.945251,122.780251 275.945251,184.000000  C246.313248,184.000000 216.625290,184.000000 186.363495,183.823517  C185.442245,183.441055 185.094833,183.235077 184.598740,182.580902  C184.428528,123.394638 184.405243,64.656555 184.400589,5.918469  C184.400513,4.936653 184.626801,3.954818 184.913239,2.875183  C185.052689,2.184915 185.026352,1.592458 185.000000,1.000000  z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    opacity: 1,
    stroke: "none",
    d: " M184.747467,2.972992  C184.626801,3.954818 184.400513,4.936653 184.400589,5.918469  C184.405243,64.656555 184.428528,123.394638 184.433014,182.839874  C184.277328,183.697998 184.138672,183.848999 184.000000,184.000000  C153.979111,184.000000 123.958214,184.000000 93.290680,183.561325  C92.624039,123.389786 92.602028,63.656918 92.601341,3.924050  C92.601326,2.949368 92.861336,1.974684 93.000000,1.000000  C123.020897,1.000000 153.041794,1.000000 183.717346,1.303876  C184.497177,2.062833 184.622314,2.517913 184.747467,2.972992  z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#002654",
    opacity: 1,
    stroke: "none",
    d: " M92.000000,184.000000  C61.703152,184.000000 31.406301,184.000000 1.054726,184.000000  C1.054726,123.109894 1.054726,62.219727 1.054726,1.000000  C30.686749,1.000000 60.374714,1.000000 90.531342,1.468657  C91.000000,60.182709 90.987900,118.428108 91.042313,176.673447  C91.044594,179.115936 91.666672,181.557831 92.000000,184.000000  z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#00194D",
    opacity: 1,
    stroke: "none",
    d: " M92.250000,184.000000  C91.666672,181.557831 91.044594,179.115936 91.042313,176.673447  C90.987900,118.428108 91.000000,60.182709 91.000000,1.468657  C91.444443,1.000000 91.888893,1.000000 92.666672,1.000000  C92.861336,1.974684 92.601326,2.949368 92.601341,3.924050  C92.602028,63.656918 92.624039,123.389786 92.822021,183.561325  C93.000000,184.000000 92.500000,184.000000 92.250000,184.000000  z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#CD0019",
    opacity: 1,
    stroke: "none",
    d: " M184.913239,2.875183  C184.622314,2.517913 184.497177,2.062833 184.186005,1.303876  C184.000000,1.000000 184.500000,1.000000 184.750000,1.000000  C185.026352,1.592458 185.052689,2.184915 184.913239,2.875183  z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#CD0019",
    opacity: 1,
    stroke: "none",
    d: " M184.333328,184.000000  C184.138672,183.848999 184.277328,183.697998 184.581696,183.288055  C185.094833,183.235077 185.442245,183.441055 185.894836,183.823517  C185.555557,184.000000 185.111099,184.000000 184.333328,184.000000  z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFranceFlag);
export default __webpack_public_path__ + "static/media/FranceFlag.646528e70f72ca694dd02cf73bc88200.svg";
export { ForwardRef as ReactComponent };